"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortPlans = exports.getDeductibleAmount = exports.formatHealthPlanNameWithDetail = exports.formatHealthPlanName = exports.REMOVE = exports.REGEX = void 0;
exports.REGEX = /(- .+)|(:.+)|(\(.+)|(24\/7 LIVE TELEHEALTH)|(\d{3,4}.+|)/g;
exports.REMOVE = /(-)|(:)/g;
var formatHealthPlanName = function (str) {
    var _a;
    if (!str)
        return '';
    var name = (_a = str === null || str === void 0 ? void 0 : str.replace(exports.REGEX, '')) === null || _a === void 0 ? void 0 : _a.replace('FRIDAY', 'Friday');
    return name || str;
};
exports.formatHealthPlanName = formatHealthPlanName;
var formatHealthPlanNameWithDetail = function (str) {
    var _a, _b, _c;
    if (!str)
        return '';
    var name = (_a = str === null || str === void 0 ? void 0 : str.replace(exports.REGEX, '')) === null || _a === void 0 ? void 0 : _a.replace('FRIDAY', 'Friday');
    var detail = (_c = (_b = str === null || str === void 0 ? void 0 : str.match(exports.REGEX)) === null || _b === void 0 ? void 0 : _b.join('')) === null || _c === void 0 ? void 0 : _c.replace(exports.REMOVE, '');
    return name ? { name: name, detail: detail } : { name: str, detail: '' };
};
exports.formatHealthPlanNameWithDetail = formatHealthPlanNameWithDetail;
var getDeductibleAmount = function (plan) {
    if (!plan.healthPlan.deductibles || plan.healthPlan.deductibles.length === 0) {
        return null; //indicate missing deductible data
    }
    var familyDeductibles = plan.healthPlan.deductibles.filter(function (d) { return d.familyCost === "Family"; });
    var individualDeductibles = plan.healthPlan.deductibles.filter(function (d) { return d.famiylCost === "Individual"; });
    if (familyDeductibles.length > 0) {
        //treat as family plan
        return familyDeductibles.reduce(function (total, d) { return total + d.amount; }, 0);
    }
    else if (individualDeductibles.length > 0) {
        //treat as individual plan
        return individualDeductibles.reduce(function (total, d) { return total + d.amount; }, 0);
    }
    else {
        return plan.healthPlan.deductibles.reduce(function (total, d) { return total + d.amount; }, 0);
    }
};
exports.getDeductibleAmount = getDeductibleAmount;
var sortPlans = function (plans, type) {
    switch (type) {
        case 'lowest_deductible':
            return __spreadArray([], plans, true).sort(function (a, b) {
                var deductibleA = (0, exports.getDeductibleAmount)(a);
                var deductibleB = (0, exports.getDeductibleAmount)(b);
                //handle null cases first (e.g. Humama plans without deductible data)
                if (deductibleA === null && deductibleB === null) {
                    return 0;
                }
                else if (deductibleA === null) {
                    return 1;
                }
                else if (deductibleB === null) {
                    return -1;
                }
                else {
                    return deductibleA - deductibleB;
                }
            });
        case 'lowest_premium':
            return __spreadArray([], plans, true).sort(function (a, b) {
                if (a.healthPlan.premiumWithCredit === b.healthPlan.premiumWithCredit) {
                    return a.healthPlan.individualDeductible - b.healthPlan.individualDeductible;
                }
                else {
                    return a.healthPlan.premiumWithCredit - b.healthPlan.premiumWithCredit;
                }
            });
        case 'recommended':
        default:
            return plans;
    }
};
exports.sortPlans = sortPlans;
